document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('PopularSearchPopup');
  if (!modal) return;


  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = modal.querySelector('.popular-search-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Close modal when clicking outside the content box (dark overlay) or on close buttons
  modal.addEventListener('click', (e) => {
    if (!e.target.closest('.popular-search-modal__content') || e.target.closest('.js-close-popular-search')) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  // Global delegation for opening popular search modal
  document.addEventListener('click', (e) => {
    if (modal.classList.contains('is-open')) return;

    const trigger = e.target.closest(
      '.js-open-popular-search, a[href="#PopularSearchPopup"], .popular-search a, [data-open-popular-search]'
    );
    if (trigger) {
      e.preventDefault();
      openModal();
      return;
    }

    // Check if clicked link text contains "Popular Search"
    const link = e.target.closest('a');
    if (link && !modal.contains(link) && link.textContent && link.textContent.trim().toLowerCase().includes('popular search')) {
      e.preventDefault();
      openModal();
    }
  });
});
